import React from 'react'
import { bool, func } from 'prop-types'

const Spinner = ({
  isLoading,
  hasError,
  isEmpty,
  runKeen
}) => {
  if (isLoading && !hasError) {
    return (
      <div className='spinner'>
        <div className='rect1' />
        <div className='rect2' />
        <div className='rect3' />
        <div className='rect4' />
        <div className='rect5' />
      </div>
    )
  } else if (hasError) {
    return (
      <div className='spinner-error'>
        <h4>Ocorreu um erro ao carregar os dados.</h4>
        <a className='btn btn-link' onClick={runKeen}>Tentar novamente.</a>
      </div>
    )
  } else if (isEmpty) {
    return (
      <div className='spinner-error'>
        <h4>Não há dados para este período</h4>
      </div>
    )
  } else {
    return false
  }
}

Spinner.propTypes = {
  isLoading: bool,
  hasError: bool,
  isEmpty: bool,
  runKeen: func
}

export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner.js